<template>
    <main class="container" role="main">
        <div class="row no-gutters clearfix">
            <div class="col-12">

                <!-- Criar -->
                <button
                    class="btn btn-success mb-3"
                    @click="startCreate"
                >
                    <i class="fas fa-plus-circle fa-fw"></i>
                    Criar Novo Projeto
                </button>

                <!-- Form Novo -->
                <div v-if="creating" class="mb-4">
                    <input
                        v-model="form.name"
                        class="form-control mb-2"
                        placeholder="Nome do projeto"
                        style="width:50%"
                    />

                    <multiselect 
                        v-model="selectedQueues" 
                        :options="availableQueues" 
                        :multiple="true" 
                        :close-on-select="false"
						:clear-on-select="false" 
                        select-label="Selecionar" 
                        deselect-label="Remover" 
                        selected-label="Selecionada"
						:preserve-search="true" 
                        placeholder="Selecione as filas" 
                        label="name" 
                        track-by="id"
                        :searchable="true" 
                        style="font-size: 12px;"
                    >
						<template slot="selection" slot-scope="{ values, search, isOpen }">
							<span class="multiselect__single"
								v-if="selectedQueues.length" 
								v-show="!isOpen">{{ selectedQueues.length }} {{ selectedQueues.length === 1 ? 'fila selecionada' : 'filas selecionadas' }}
							</span>
                        </template>
					</multiselect>

                    <div class="mt-2">
                        <button
                            class="btn btn-success me-2"
                            @click="store"
                        >
                            <i class="fas fa-save"></i> Salvar
                        </button>

                        <button
                            class="btn btn-secondary"
                            @click="cancel"
                        >
                            <i class="fas fa-times"></i> Cancelar
                        </button>
                    </div>
                </div>

                <!-- Lista -->
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th class="text-center">Nome</th>
                            <th class="text-center">Filas selecionadas</th>
                            <th class="text-center">Filas</th>
                            <th class="text-center">Ações</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr v-for="project in projects" :key="project.id">
                            <td class="text-center">
                                <input
                                    v-model="project.name"
                                    class="form-control"
                                    :disabled="editingId !== project.id"
                                />
                            </td>

                            <td class="text-center">
                                <span>{{ project.queues.length }}</span>
                            </td>

                            <td class="text-center">
                                <multiselect 
                                    v-model="editingQueues[project.id]" 
                                    :options="availableQueuesForEditing(project.id)"
                                    :multiple="true" 
                                    :close-on-select="false"
                                    :clear-on-select="false" 
                                    select-label="Selecionar" 
                                    deselect-label="Remover" 
                                    selected-label="Selecionada"
                                    :preserve-search="true" 
                                    placeholder="Selecione as filas" 
                                    label="name" 
                                    track-by="id"
                                    :searchable="true" 
                                    style="font-size: 12px;"
                                    :disabled="editingId !== project.id"
                                >
                                </multiselect>
                            </td>

                            <td class="text-center">
                                <template v-if="editingId === project.id">
                                    <button
                                        class="btn btn-success btn-sm me-1"
                                        @click="update(project)"
                                    >
                                        <i class="fa fa-save"></i> Salvar
                                    </button>

                                    <button
                                        class="btn btn-secondary btn-sm"
                                        @click="cancelEdit"
                                    >
                                        <i class="fa fa-times"></i> Cancelar
                                    </button>
                                </template>

                                <template v-else>
                                    <button
                                        class="btn btn-primary btn-sm me-1"
                                        @click="edit(project)"
                                    >
                                        <i class="fa fa-edit"></i> Editar
                                    </button>

                                    <button
                                        class="btn btn-danger btn-sm"
                                        @click="destroy(project.id)"
                                    >
                                        <i class="fa fa-trash"></i> Excluir
                                    </button>
                                </template>
                            </td>
                        </tr>
                    </tbody>
                </table>

            </div>
        </div>
    </main>
</template>

<script>
import Vue from 'vue';
import LoggedUsersList from './modals/LoggedUsersList.vue';
export default {
    name: 'Projects',

    data() {
        return {
            projects: [],
            creating: false,
            editingId: null,
            form: {
                name: '',
                queues: []
            },
			queuesList: [],

            selectedQueues: [],     // criação
            editingQueues: {},      // edição por projeto

            originalProject: null,  // snapshot do projeto original
        }
    },

    computed: {
        availableQueues() {
            const usedIds = this.projects.flatMap(p => p.queues);
            return this.queuesList.filter(q => !usedIds.includes(q.id));
        },

        availableQueuesForEditing() {
            return (projectId) => {
                const usedIds = this.projects
                    .filter(p => p.id !== projectId)
                    .flatMap(p => p.queues);
                return this.queuesList.filter(q => !usedIds.includes(q.id));
            };
        }
    },

    mounted() {
        this.getUserQueues();
        this.fetchProjects();
    },

    methods: {
        async getUserQueues() {
			try {
				this.queuesList = [];
				axios.get('/listQueue').then(({ data }) => {
					if (data?.length) {
						data.map(el => this.queuesList.push({ id: el.id.toString(), name: el.alias || el.name }))
					}
				})
			} catch (err) {
				this.error = 'Erro ao obter filas de telefonia'
				console.error('Fetch queues error:', err)
			}
		},
        fetchProjects() {
            axios.get('/projects/list')
                .then(res => {
                    this.projects = res.data;
                });
        },

        startCreate() {
            this.creating = true
        },

        store() {
            axios.post('/projects/create', {
                name: this.form.name,
                queues: this.selectedQueues.map(q => q.id.toString()),
            }).then(() => {
                Swal.fire('Feito!', 'Projeto criado com sucesso.', 'success')
                this.cancel()
                this.fetchProjects()
            }).catch(() => {
                Swal.fire('Erro!', 'Falha ao criar projeto.', 'error')
            })
        },

        cancel() {
            this.creating = false;
            this.form.name = '';
            this.form.queues = [];
            this.selectedQueues = [];
        },

        edit(project) {
            this.editingId = project.id;

            this.originalProject = {
                id: project.id,
                name: project.name,
                queues: [...project.queues],
            }

            this.$set(
                this.editingQueues,
                project.id,
                this.queuesList.filter(q => project.queues.includes(q.id))
            );
        },

        cancelEdit() {
            const project = this.projects.find(p => p.id === this.editingId);
            if (!project || !this.originalProject) return;

            project.name = this.originalProject.name;
            project.queues = [...this.originalProject.queues];

            delete this.editingQueues[project.id];

            this.editingId = null;
            this.originalProject = null;
        },

        update(project) {
            axios.put('/projects/update', {
                id: project.id,
                name: project.name,
                queues: this.editingQueues[project.id].map(q => q.id.toString()),
            }).then(() => {
                Swal.fire('Feito!', 'Projeto atualizado.', 'success');

                project.queues = this.editingQueues[project.id].map(q => q.id);

                this.$delete(this.editingQueues, project.id);
                this.editingId = null;
                this.originalProject = null;
            }).catch((error) => {
                let swalConfig = {
                    title: 'Erro!',
                    icon: 'error',
                    text: 'Falha ao atualizar o projeto.'
                };

                if (error.response && error.response.data) {
                    const data = error.response.data;

                    if (data.logged_details && data.logged_details.length > 0) {
                        // 1. Prepara a classe do componente
                        const ComponentClass = Vue.extend(LoggedUsersList);
                        
                        // 2. Instancia o componente passando os props da API
                        const instance = new ComponentClass({
                            propsData: {
                                message: data.error,
                                users: data.logged_details
                            }
                        });
                        
                        // 3. Monta o componente na memória (sem jogar na tela ainda)
                        instance.$mount();

                        // 4. Configura o alerta passando o $el (elemento HTML nativo gerado pelo Vue)
                        swalConfig = {
                            title: 'Atenção!',
                            icon: 'warning',
                            html: instance.$el,
                            // IMPORTANTE: Destruir a instância do Vue quando o alerta fechar para liberar memória
                            didClose: () => {
                                instance.$destroy();
                            }
                        };
                    } 
                    else if (data.message) {
                        swalConfig.title = 'Atenção!';
                        swalConfig.icon = 'warning';
                        swalConfig.text = data.message;
                    } 
                    else if (data.error) {
                        swalConfig.text = data.error;
                    }
                }

                Swal.fire(swalConfig);
            })
        },

        destroy(id) {
            Swal.fire({
                title: 'Deseja excluir?',
                text: "Esta ação não poderá ser desfeita!",
                type: 'warning', // type em vez de icon
                showCancelButton: true,
                confirmButtonColor: '#d33',
                confirmButtonText: 'Excluir',
                cancelButtonText: 'Cancelar'
            }).then((result) => {
                
                // Pega a confirmação do jeito antigo (result.value)
                if (!result.value) return;

                Swal.fire({
                    title: 'Excluindo...',
                    allowOutsideClick: false,
                    onBeforeOpen: () => { // onBeforeOpen em vez de didOpen
                        Swal.showLoading();
                    }
                });

                axios.delete(`/projects/delete?id=${id}`)
                    .then(() => {
                        Swal.fire('Feito!', 'Projeto excluído com sucesso.', 'success');
                        this.fetchProjects();
                    })
                    .catch((error) => {
                        console.error("Erro na exclusão:", error);
                        let mensagemErro = 'Falha ao excluir o projeto.';
                        
                        if (error.response && error.response.data && error.response.data.message) {
                            mensagemErro = error.response.data.message;
                        }

                        Swal.fire('Erro!', mensagemErro, 'error');
                    });
            })
        }
    }
}
</script>
